// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as WalletStateMapper from "../../../../partner-dashboard/app/wallet/entity-mapper/WalletStateMapper.bs.js";
import * as BulkReasonEntityMapper from "../entity-mapper/BulkReasonEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as ResponseConverterNew$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseConverterNew.bs.js";

function parseSuccessResponse(data) {
  var statusCode = Json_decode.field("status", Json_decode.string, data);
  switch (statusCode) {
    case "200" :
        return {
                TAG: /* Ok */0,
                _0: {
                  title: "Success",
                  message: "Success"
                }
              };
    case "422" :
        return {
                TAG: /* Error */1,
                _0: WalletStateMapper.BulkUploadTransactionsErrorMapper.execute(data)
              };
    default:
      return ;
  }
}

function execute(response) {
  if (typeof response === "number") {
    return ;
  }
  switch (response.TAG | 0) {
    case /* Success */0 :
        return parseSuccessResponse(response._0);
    case /* SuccessWithNoContent */1 :
        return {
                TAG: /* Ok */0,
                _0: {
                  title: "Success",
                  message: "Success"
                }
              };
    default:
      return ;
  }
}

var BulkUploadWalletTransactionsSuccessConverter = {
  parseSuccessResponse: parseSuccessResponse,
  execute: execute
};

var partial_arg = {
  execute: execute
};

var partial_arg$1 = ResponseConverterNew$Catalyst.Converter;

var BulkUploadWalletTransactionsResponseConverter = (function (param) {
      return partial_arg$1(partial_arg, param);
    })(ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = BulkReasonEntityMapper.execute;

var BulkReasonResponseConfig = {
  execute: execute$1
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var BulkReasonResponseConverter = partial_arg$2(BulkReasonResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  BulkUploadWalletTransactionsSuccessConverter ,
  BulkUploadWalletTransactionsResponseConverter ,
  BulkReasonResponseConfig ,
  BulkReasonResponseConverter ,
  
}
/* BulkUploadWalletTransactionsResponseConverter Not a pure module */
